import { post, get } from '../../../../services/request';

export const fetchRadiologistAllDDList = () => {
    return get('Radiologist/GetRadiologistAllDDList');
}; 

export const exportAuditLogs = (exportData) => {
    return post('AuditLog/GetAllAuditLogsExport', exportData);
};

export const fetchGetAllModuleFieldActionTypeDropdown = () => {
    return get('AuditLog/GetAllModuleFieldActionTypeDropdown');
}; 

export const exportGetAllAuditLogs = (payload) => {
    return post('AuditLog/GetAllAuditLogsList', payload);
};

export const GetAllAuditLogscustomreport = (payload) => {
    return post('AuditLog/GetAuditLogsCustomReport', payload);
};

export const exportAuditLogscustomreport = (payload) => {
    return post('AuditLog/ExportAuditCustomReport', payload);
};